import React, { Fragment } from 'react';
import s from './style.module.css';

type MemberVoiceCardProps = {
    id: number;
    image: string;
    title: string;
    memberName: string;
    work: string;
    courses: Array<{ id: number; name: string }>;
};

export const MemberVoiceCard = (props: MemberVoiceCardProps) => {
    return (
        <div className={s.member_voice_card}>
            <div className={s.image}>
                <img src={props.image} />
            </div>
            <div className={s.info}>
                <h4>{props.title}</h4>
                <p className={s.name}>{props.memberName}様</p>
                <p className={s.work}>{props.work}</p>
                <div className={s.detail_user_clubs}>
                    <div className={s.detail_club_title}>
                        <span>所属コース</span>
                        <span className={s.colon}>：</span>
                    </div>
                    <div className={s.detail_clubs}>
                        {props.courses.length >= 2 ? (
                            <>
                                <a href={`/courses/${props.courses[0].id}`}>{props.courses[0].name}</a>
                                <span> 他{props.courses.length - 1}コース</span>
                            </>
                        ) : (
                            props.courses.map((c, i) => (
                                <Fragment key={c.id}>
                                    <a href={`/courses/${c.id}`}>{c.name}</a>
                                    {i !== props.courses.length - 1 ? <span>/</span> : ''}
                                </Fragment>
                            ))
                        )}
                    </div>
                </div>
                <p className={s.link}>
                    <a href={`/member_voices/${props.id}`}>詳細を見る&gt;</a>
                </p>
            </div>
        </div>
    );
};

export default MemberVoiceCard;
